module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_12.a8be7f3a.mp3";